var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.resizeEnabled)?_c('div',{staticClass:"resize-drag",on:{"mousedown":_vm.resizeStart,"mouseup":_vm.resizeEnd}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"resize-center"},[_c('div',{staticClass:"resize-marker"}),_c('div',{staticClass:"resize-marker"})])
}]

export { render, staticRenderFns }